import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const Description = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <PresetsTextField
        fullWidth
        label="Description"
        multiline
        minRows={2}
        value={opsPlan?.description}
        suggestionPath="opsPlan.description"
        suggestionLabel="Descriptions from templates"
        InputLabelProps={{
          shrink: !!opsPlan?.description,
        }}
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            description: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(Description)
